"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    card: {
      padding: theme.spacing(0.5),
      paddingLeft: theme.spacing(1)
    }
  };
});
function SttCardHeader(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], _extends({
    className: classes.card
  }, props));
}
var _default = SttCardHeader;
exports["default"] = _default;